import { z } from 'zod';
/** Regole password: minimo 10 caratteri, almeno una lettera e un numero. */
export const passwordSchema = z
    .string()
    .min(10, 'La password deve avere almeno 10 caratteri')
    .max(128, 'La password non può superare 128 caratteri')
    .regex(/[a-zA-Z]/, 'La password deve contenere almeno una lettera')
    .regex(/[0-9]/, 'La password deve contenere almeno un numero');
export const emailSchema = z
    .string()
    .trim()
    .toLowerCase()
    .email('Inserisci un indirizzo email valido')
    .max(254);
export const registerSchema = z.object({
    email: emailSchema,
    password: passwordSchema,
    displayName: z
        .string()
        .trim()
        .min(2, 'Il nome deve avere almeno 2 caratteri')
        .max(50, 'Il nome non può superare 50 caratteri'),
});
export const loginSchema = z.object({
    email: emailSchema,
    password: z.string().min(1, 'Inserisci la password'),
});
export const requestPasswordResetSchema = z.object({
    email: emailSchema,
});
export const resetPasswordSchema = z.object({
    token: z.string().min(1),
    password: passwordSchema,
});
export const verifyEmailSchema = z.object({
    token: z.string().min(1),
});
//# sourceMappingURL=auth.js.map